import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import classNames from 'classnames';
import s from './TextField.css';

const defaultText = '';
const defaultPlaceholder = 'Write here...';
const defaultAutofocus = false;
const defaultMultiline = false;

/**
 * A text input
 */
export default class TextField extends PureComponent {
  constructor(
    props = {
      text: defaultText,
      placeholder: defaultPlaceholder,
      autofocus: defaultAutofocus,
      multiline: defaultMultiline,
      maxlength,
      onChange,
      onKeyPress,
      className,
      style,
      id,
    }
  ) {
    super(props);

    this.state = {
      text: this.props.text,
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.text || newProps.text === '') {
      this.setState({
        text: newProps.text,
      });
    }
  }

  handleChange = event => {
    this.setState({text: event.target.value});
  };

  render() {
    const {
      placeholder,
      autofocus,
      multiline,
      maxlength,
      onChange,
      onKeyPress,
      className,
      style,
      id,
    } = this.props;
    const {text} = this.state;

    if (!multiline) {
      return (
        <input
          id={id}
          type="text"
          className={classNames(s.TextField, className)}
          style={style}
          placeholder={placeholder}
          value={text}
          onChange={onChange || this.handleChange}
          autoFocus={autofocus}
          onKeyPress={onKeyPress}
        />
      );
    }

    return (
      <textarea
        id={id}
        className={classNames(s.TextField, s.TextArea, className)}
        style={style}
        placeholder={placeholder}
        value={text}
        onChange={onChange || this.handleChange}
        autoFocus={autofocus}
        maxLength={maxlength}
        onKeyPress={onKeyPress}
      />
    );
  }
}
TextField.propTypes = {
  /**
   * Field text
   */
  text: PropTypes.string,
  /**
   * Field placeholder
   */
  placeholder: PropTypes.string,
  /**
   * Change event handler
   */
  onChange: PropTypes.func,
  /**
   * Enable autofocus
   */
  autofocus: PropTypes.bool,
  /**
   * If false, output an input element, otherwise output a textarea
   */
  multiline: PropTypes.bool,
  /**
   * Max number of characters a user can input
   */
  maxlength: PropTypes.number,
  /**
   * Container class name
   */
  className: PropTypes.string,
  /**
   * Container styles
   */
  style: PropTypes.object,
};
TextField.defaultProps = {
  text: defaultText,
  placeholder: defaultPlaceholder,
  autofocus: defaultAutofocus,
  multiline: defaultMultiline,
};
